<template>
  <div :class="isLarge ? 'col-lg-12' : 'col-lg-4'" class="mb-3">
    <div class="card mb-3">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <h5><i :class="icon"></i> {{ title }}</h5>
        <div v-if="withControls">
          <button
            class="btn btn-sm btn-outline-secondary me-2"
            @click="$emit('refresh')"
            :disabled="isLoading"
          >
            <i
              :class="[
                'bi bi-arrow-clockwise',
                { 'spinner-border spinner-border-sm': isLoading },
              ]"
            ></i>
          </button>
          <button
            class="btn btn-sm btn-outline-secondary"
            @click="$store.dispatch('cards/toggleCard', section)"
          >
            <i
              :class="
                $store.getters['cards/isCardCollapsed'](section)
                  ? 'bi bi-chevron-down'
                  : 'bi bi-chevron-up'
              "
            ></i>
          </button>
        </div>
      </div>
      <div
        :class="{ collapse: $store.getters['cards/isCardCollapsed'](section) && withControls }"
      >
        <div :class="fullHeight ? '' : 'card-body'">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    section: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isLarge: {
      type: Boolean,
      default: false,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
    withControls: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getBorderClass(value, limits, reverse) {
      if (value <= limits[0])
        return reverse ? "border-left-red" : "border-left-green";
      if (value > limits[0] && value < limits[1]) return "border-left-yellow";
      return reverse ? "border-left-green" : "border-left-red";
    },
    getBadgeClass(value, limits) {
      if (value <= limits[0]) return "bg-danger";
      if (value > limits[0] && value < limits[1]) return "bg-warning";
      return "bg-light text-dark";
    },
  },
};
</script>
<style scoped>
.card-body {
  max-height: 500px;
  overflow-y: auto;
}
.card-header i {
  color: #6c757d !important;
}
.spinner-border {
  margin: 0px;
}
.spinner-border-xs {
  border-width: 0px;
}
.btn:hover i {
  color: #d1d1d1 !important;
}
.badge {
  font-size: 0.85rem;
  padding: 0.4em 0.75em;
}
.tab-title {
  position: relative;
  top: 5px;
}
</style>  